import { api } from "@/lib/api";
import { hideLoader, showLoader } from "@/store/slices/loaderSlice";
import { store } from "@/store/store";

class SettingsService {
  async get() {
    store.dispatch(showLoader());
    try {
      const { data, ok }: any = await api.get(
        `${process.env.REACT_APP_BASE_URL}/api/Settings`,
        {
          $filter: `IsDeleted ne true`,
        }
      );
      if (ok) {
        store.dispatch(hideLoader());
        return { data, error: null };
      }

      return { data: null, error: data };
    } catch (error) {
      store.dispatch(hideLoader());
      return { data: null, error: error };
    } finally {
      store.dispatch(hideLoader());
    }
  }
}

const settingsSvc = new SettingsService();

export default settingsSvc;
